import Overlay from "./overlay";
import { useGlobalAppIssueContext } from "./provider";

const GlobalAppIssueOverlay: FC<{}> = () => {
  const { issues } = useGlobalAppIssueContext();
  return <Overlay issues={issues} />;
};

export default GlobalAppIssueOverlay;
